import { render } from "./product-card-carousel.vue?vue&type=template&id=ed2b614e"
import script from "./product-card-carousel.vue?vue&type=script&lang=js"
export * from "./product-card-carousel.vue?vue&type=script&lang=js"

import "./product-card-carousel.vue?vue&type=style&index=0&id=ed2b614e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__